// src/page/auth/LoginPage.js

import LoginModal from "./LoginModal";

export default function LoginPage() {
    return (
        // 이 래퍼에 Tailwind 클래스(flex items-center ... min-h-screen)가 걸려 있었으나
        // 프로젝트에 Tailwind 가 없어 전부 무시됐다. 다만 화면은 멀쩡했는데,
        // LoginModal 이 스스로 minHeight:100vh + 중앙정렬을 하기 때문이다.
        // 죽은 클래스를 지우기만 하고 정렬은 LoginModal 에 그대로 맡긴다(중복 정의 방지).
        <div>
            <LoginModal onLoginSuccess={() => {
                // 로그인 성공하면 메인으로 리다이렉트
                window.location.href = "/";
            }} />
        </div>
    );
}